// extracted by mini-css-extract-plugin
module.exports = {"strokeTextBlueLight":"Controls_strokeTextBlueLight__WtLdQ","strokeTextGreenSaturated":"Controls_strokeTextGreenSaturated__ML_qP"};